// extracted by mini-css-extract-plugin
export default {"header":"header_header__CgaBB","header_title":"header_header_title__7nexg"};